import { render } from "./EnquiryTitle.vue?vue&type=template&id=38ed5e5a"
import script from "./EnquiryTitle.vue?vue&type=script&lang=js"
export * from "./EnquiryTitle.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__